import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import { useAppDispatch } from '@xver/hooks/useAppDispatch';
import { ME_QUERY_KEY } from '@xver/hooks/useMeQuery';
import { getErrorMessage } from '@xver/utils/error';
import { requestAuthUser } from '@xver/store/auth/auth.actions';
import { useTranslation } from 'react-i18next';

export function useRedeemCouponMutation() {
    const { t } = useTranslation('coupon');
    const queryClient = useQueryClient();
    const dispatch = useAppDispatch();

    return useMutation({
        mutationFn: (code: string) => Endpoints.v1.Billing.redeemCoupon(code),
        onSuccess: async (response) => {
            notifications.show({
                title: t('toast.successTitle'),
                message: response?.message ?? t('toast.successMessage'),
                icon: <IconCheck size={18} color="#22c55e" />,
            });
            await queryClient.invalidateQueries({ queryKey: ME_QUERY_KEY });
            dispatch(requestAuthUser());
        },
        onError: (err: unknown) => {
            notifications.show({
                title: t('toast.errorTitle'),
                message: getErrorMessage(err) ?? t('toast.errorMessage'),
                icon: <IconExclamationCircle size={18} color="#eb5757" />,
            });
        },
    });
}
